<template>
    <div class="body-box" :style="'padding-bottom: '+footbottom+'px;'">
        <div class="container" id="app" v-cloak>
            <div class="row toprem">
                <div class="col-md-8 p-0 t-right">
                    <img :src="detail.Cover" alt="" srcset="" class="head-img" v-if="isVideo==false">
                    <video :src="videoUrl" class="head-video" v-show="isVideo==true" controls autoplay
                        webkit-playsinline='true' playsinline='true' controlsList="nodownload" id="video"></video>
                </div>
                <div class="p-3 col-md-4" style="position: relative;">
                    
                    <div class="flex f-between">
                        <div class="fw-bold fon-16" style="width:80%">{{detail.Name}}</div>
                        <div class="share" @click="showBuySuccessPopup1=true">
                        <img src="../../img/merge/share.png"><br>
                        <span class="fon-12 ma-t-10">分享</span>
                    </div>
                    </div>
                    <div class="mt-2 w-s-p fon-14">{{detail.Summary}}</div>
                    <div class="flex bg-f5f7fe fon-14 p-1 b-r-5 mt-3 f-around  fz-15" style="color:#000">
                        <div>{{detail.SaleCount}}人购买</div>
                        <div class="ma-l-20">{{detail.ViewCount }}人查阅</div>
                        <div class="ma-l-20 c-red" v-if="detail.IsBuy">已助力</div>
                    </div>

                    <div class="text-center" v-if="!detail.IsBuy">观影劵<span class="trueprice">￥{{detail.Price}}</span></div>
                    <div v-if="!detail.IsBuy">
                        <button class="btn-buy c-pointer mt-3 " :class="buybtndisabled?'grayc':''" @click="buy()" :disabled="buybtndisabled">我 要 助 力</button>
                    </div>
                    <div class="text-center tips ma-t-20 fon-14" v-show="detail.IsBuy">点击视频列表观看影片</div>
                </div>

            </div>

            <div class="row mt-3 jcenter">
                <div class="flex p-3 mt-2">
                    <div class="item" :class="active==0?'active':''" @click="active=0">展映介绍</div>
                    <div class="item" :class="active==1?'active':''" @click="active=1" v-show="detail.IsBuy">视频列表</div>
                </div>
                <div v-if="active==0" class="p-3">
                    <div v-html="detail.Detail" class="v-html"></div>
                </div>
                <div v-if="active==1" class="p-3 row jcenter bg-black">

                    <div v-for="(item,index) in detail.Video" :key="index" class="movie-list mb-1 col-md-3 mb-3 curm "
                        @click="playvod(item)">
                        <img :src="item.Cover" alt="" srcset="" class="movie-list-img col-3 ">
                        <div class="">
                            <div class="fw-bold ma-2 titles text-center">{{item.Name}}</div>
                            <div class="summary ma-2" :title="item.Summary">{{item.Summary}}</div>
                        </div>
                        <div class="superscript" v-if="item.CanPlay">
                            <div class="rect"></div>
                            <div class="desc">点击播放</div>
                        </div>

                    </div>
                </div>
            </div>

            <!-- 扫码弹框 -->
            <div class="qrcode-popup" v-show="isQrcodePopup" @click="closePopup">
                <div class="popup-main" v-cloak>
                    <div class="t-center" v-show="!isPayResult">
                        <div class="bold">支付金额：<span class="fon-20 c-red">{{detail.Price}}元</span></div>
                        <div id="qrcode" class="mt-10"></div>
                        <div class="mt-10">微信扫码支付</div>
                    </div>
                    <div class="t-center" v-show="isPayResult">
                        <h2 class="bold">支付成功</h2>
                        <div>
                            <i class="iconfont icon-chenggong icon-success"></i>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 购买成功后的弹框 -->
            <div class="buySuccess-popup" v-if="showBuySuccessPopup" @click="showBuySuccessPopup=false">
                <div class="popup-main">
                    <div class="t-center">
                        <p class="bold psuc mb-0">支付成功！<br>您可以点击视频列表进行观看！</p>
                    </div>
                    <div class="t-center" @click="event.stopPropagation()">
                        <img src="../../img/merge/20220930164223.png" alt="" srcset="">
                    </div>
                    <div class="t-center">
                        <h2 class="bold psuc">点击关闭<br>也可以长按保存此图分享哦！</h2>
                    </div>
                </div>
            </div>
            <div class="buySuccess-popup" v-if="showBuySuccessPopup1" @click="showBuySuccessPopup1=false">
                <div class="popup-main">
                    <div class="t-center" @click="event.stopPropagation()">
                        <img src="../../img/merge/20220930164223.png" alt="" srcset="">
                    </div>
                    <div class="t-center">
                        <h2 class="bold psuc1">长按保存，分享朋友圈助力!</h2>
                    </div>
                </div>
            </div>
            <div id="gotopBtn" onclick="topFunction()"><img src="../../img/merge/gotop.png" width="45"></div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    @import "../../../css/bootstrap.min.css";
    @import "../../../css/commons.css";

    button{
        padding:0;
    }
    body {
        background-color: #f5f7fa;
    }

    .carouselTitle {
        width: 100%;
        height: 34px;
        font-size: 20px;
        font-weight: 400;
        color: #000000;
        margin: 0 auto;
        text-align: center;
    }

    .body-box {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 100vh;

    }

    @media (max-width:768px) {
        .con-top {
            margin-top: 100px;
        }

        .movie-list-img {
            width: 100%;
        }

    }

    @media (min-width:768px) {
        .toprem {
            margin-top: 1.5rem;
        }

        .con-top {
            margin-top: 200px;
        }

        .movie-list-img {
            width: 100%;
        }

        .curm {
            width: 22%
        }
    }

    .head-img {
        max-height: 90vh;
        width: 100%;
        object-fit: contain;
    }

    .head-video {
        width: 100%;
        object-fit: contain;
    }

    .bg-fff {
        background-color: #fff;
    }

    .btn-buy {
        height: 50px;
        line-height: 50px;
        color: #fff;
        border-radius: 25px;
        text-align: center;
        border: none;
        width: 100%;
        background-color: #FB004D;
    }

    .item {
        cursor: pointer;
        margin-right: 20px;

    }

    .active {
        font-weight: bold;
        color: #FB004D;
        position: relative;
    }

    .active::after {
        content: '';
        width: 100%;
        height: 2px;
        background-color: #FB004D;
        position: absolute;
        left: 0;
        bottom: -5px;
    }

    .btn-toMovie {
        width: 70px;
        height: 30px;
        background-color: #FB004D;
        border-radius: 5px;
        text-align: center;
        line-height: 30px;
        color: #fff;
        font-size: 14px;
    }

    .movie-list {
        border: 1px solid #e5e5e5;
        border-radius: 10px;
        margin: 0.5rem;
    }

    .movie-list-img {
        height: 200px;
        object-fit: contain;
    }

    .w-s-p {
        white-space: pre-line;
    }

    #qrcode {
        display: flex;
        justify-content: center;
    }

    .icon-success {
        font-size: 100px;
        color: #52c41a;
    }

    .qrcode-popup {
        background-color: rgba(0, 0, 0, 0.571);
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .qrcode-popup .popup-main {
        background-color: #fff;
        padding: 50px;
        border-radius: 5px;

    }

    .v-html img {
        max-width: 100%;
    }

    [v-cloak] {
        display: none;
    }

    .b-r-5 {
        border-radius: 20px;
    }

    .bg-f5f7fe {
        background-color: #f5f7fe;
    }

    .f-around {
        justify-content: center
    }

    .fz-15 {
        font-size: 14px;
    }

    .showprice {
        text-decoration: line-through;
        color: #999;
    }

    .trueprice {
        color: red;
        font-size: 30px
    }

    .m-t-2 {
        margin-top: 0.5rem;
    }

    .ma-2{
        margin: 0.5rem;
    }

    .summary {
        margin-top: 0.2rem;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .titles{
        height: 2.8rem;
    }

    .curm {
        cursor: pointer;
        position: relative;
        /* background-color: #fff; */
    }

    /************以下为具体实现************/

    .superscript {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 8rem;
        height: 8rem;
        overflow: hidden;
    }

    /* 使用矩形旋转, 和父节点的 overflow:hidden 配合 */
    .superscript .rect {
        width: 8rem;
        height: 8rem;
        margin: -4rem 0 0 -4rem;
        background: red;
        transform: rotateZ(45deg);
    }

    .superscript .desc {
        position: absolute;
        top: 17%;
        left: 0%;
        z-index: 1;
        color: #fff;
        ;
        transform: rotateZ(-45deg);
    }

    #gotopBtn {
        display: none;
        /* 默认隐藏 */
        position: fixed;
        bottom: 20px;
        right: 30px;
        z-index: 99;
        border: none;
        outline: none;
        /* 设置背景颜色，你可以设置自己想要的颜色或图片 */
        color: white;
        /* 文本颜色 */
        cursor: pointer;
        padding: 15px;
        border-radius: 10px;
        /* 圆角 */
    }

    .jcenter {
        justify-content: center
    }

    .buySuccess-popup {
        background-color: rgba(0, 0, 0, 0.571);
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .buySuccess-popup .popup-main {
        border-radius: 5px;
        height: 50vh;
        color: #fff;
    }

    .buySuccess-popup .popup-main img {
        height: 50vh;
        width: auto;
    }

    .psuc1 {
        color: red;
        padding: 10px;
        font-size: 14px;
        line-height: 20px;
    }

    .psuc {
        background-color: #fff;
        color: red;
        padding: 10px;
        font-size: 14px;
        line-height: 20px;
    }

    .grayc {
        background-color: #999;
    }

    .tips {
        color: red;
        font-size: 15px;
        ;
    }

    .share {
        height: 2.8rem;
        width: 2.8rem;
        // position: absolute;
        // right: 1.2rem;
        // top: 1.4rem;
        text-align: center;

    }

    .share img {
        height: 1.8rem;
        width: 1.8rem;
        filter: invert(1);
    }

    .body-box {
        background-color: #000 !important;
        color: #fff;
    }

    video::-internal-media-controls-download-button {
        display: none;
    }

    video::-webkit-media-controls-enclosure {
        overflow: hidden;
    }

    video::-webkit-media-controls-panel {
        width: calc(100% + 30px);
    }
</style>
<script>
    import {getVodTicketDetail,postVodTicketAdd,orderPay,PayResult,postVodTicketWatchLog,getJsApiConfig} from "../../api.js";
    import QRCode from "qrcodejs2";
    import wx from "weixin-js-sdk";
    export default {
        name: "merge",
        data() {
            return {
                detail: {},
                active: 0,
                videoUrl: '',
                isVideo: false,
                id: '5412984914400477343',
                isWeixin: false,//是否在微信浏览器内
                isPayResult: false,//扫码支付回调结果
                isQrcodePopup: false,//是否显示扫码弹框
                payRep: {},
                tInterval1: null,
                showBuySuccessPopup: false,
                buybtndisabled: false,
                showBuySuccessPopup1: false,
                footbottom:123,
            };
        },
        created() {
            console.log("开始开发")
            this.id = this.$route.query.id
            this.loadData();
            this.$nextTick(() => {
                if(document.getElementById("mergefoot").scrollHeight!=null&&document.getElementById("mergefoot").scrollHeight>0){
                    this.footbottom=document.getElementById("mergefoot").scrollHeight;
                }
            })
        },
        
        methods: {
            //跳转链接
            toBanerHref() {
                let i = this.$refs.carousel.activeIndex;
                let item = this.bannerlist[i];
                console.log(item);
                if (!item.Href) {
                    return;
                } else {
                    location.href = item.Href;
                }
            },
            //获取数据
            loadData() {
                let data = {
                    id:this.id,
                };
                getVodTicketDetail(data).then((res) => {
                    console.log(res);
                    this.detail = res.data.Data;
                    this.active = this.detail.IsBuy ? 1 : 0

                    if (this.isWeixin) {
                        //设置分享信息
                        this.setShartMesage()
                    }
                });
            },
            //购买
            buy() {
                var that = this;
                that.buybtndisabled = true;
                //如果没有登录，就先登录
                let token = localStorage.getItem('AccessToken');
                if (!token) {
                    location.href = 'login.html?page=movie'
                    that.buybtndisabled = false;
                }

                let openid = localStorage.getItem('openid')
                console.log(openid)
                //如果微信浏览器中没有openid就重新登录
                if (this.isWeixin && !openid) {
                    location.href = 'login.html?page=movie'
                    that.buybtndisabled = false;
                    return
                }
                postVodTicketAdd({
                    token: localStorage.getItem('AccessToken'),
                    Id: this.id
                }).then((result) => {
                    if (result.data.Code != 0) {
                        alert(result.data.Message)
                        return
                    }
                    orderPay({
                        token: localStorage.getItem('AccessToken'),
                        Key: result.data.Data.Key,
                        OpenId: openid,
                        Type: this.isWeixin ? 'weixinm' : 'weixin'
                    }).then((res) => {
                        that.buybtndisabled = false;
                        if (res.data.Code != 0) {
                            alert(res.data.Message)
                            return
                        }
                        if (this.isWeixin) {
                            this.wxPay(res.data.Data.Data)
                        } else {
                            this.isQrcodePopup = true
                            this.payRep = res.data.Data
                            new QRCode(document.getElementById("qrcode"), res.data.Data.Qrcode);

                            //循环获取扫码支付结果
                            this.tInterval1 = setInterval(() => {
                                if (this.isPayResult) {
                                    clearInterval(this.tInterval1)
                                } else {
                                    this.isPaySuccess()
                                }
                            }, 1500)
                        }
                    });
                });
            },
            //微信内支付
            wxPay(weixin) {
                wx.config({
                    debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
                    appId: weixin.AppId, // 必填，公众号的唯一标识
                    timestamp: weixin.TimeStamp, // 必填，生成签名的时间戳
                    nonceStr: weixin.NonceStr, // 必填，生成签名的随机串
                    signature: weixin.PaySign,// 必填，签名
                    jsApiList: ['chooseWXPay'] // 必填，需要使用的 JS 接口列表
                });
                wx.ready(function () {
                    //发起微信支付
                    wx.chooseWXPay({
                        timestamp: weixin.TimeStamp, // 支付签名时间戳，注意微信 jssdk 中的所有使用 timestamp 字段均为小写。但最新版的支付后台生成签名使用的 timeStamp 字段名需大写其中的 S 字符
                        nonceStr: weixin.NonceStr, // 支付签名随机串，不长于 32 位
                        package: weixin.Package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                        signType: weixin.SignType, // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
                        paySign: weixin.PaySign, // 支付签名
                        success: function (res) {
                            console.log(res);
                            // 支付成功后的回调函数
                            this.loadData(true)

                            this.showBuySuccessPopup = true
                        }
                    });
                });

            },
            //是否支付成功，循环请求
            isPaySuccess() {
                PayResult({ PayId: this.payRep.PayId }).then((res) => {
                    if (res.data.Code != 0) {
                        alert(res.data.Message)
                        return
                    }
                    this.isPayResult = res.data.Data
                    if (this.isPayResult) {
                        setTimeout(() => {
                            this.isQrcodePopup = false
                            this.loadData()
                        }, 1500);
                    }
                });
            },
            //关闭支付弹框
            closePopup() {
                this.isQrcodePopup = false
                clearInterval(this.tInterval1)
                document.getElementById("qrcode").innerHTML = ''
            },
            playvod(item) {
                if (item.CanPlay) {
                    this.videoUrl = item.Url;
                    this.isVideo = true;
                    this.addLog(item.Id)
                }
            },
             //增加观看记录
            addLog(id) {
                document.getElementById('video').oncontextmenu = function () { return false }//禁用视频标签右键

                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;

                postVodTicketWatchLog({ Id: id }).then((res) => {
                     if (res.data.Code != 0) {
                        alert(res.data.Message)
                        return
                    }
                });
            },
            //自定义分享
            setShartMesage() {
                getJsApiConfig({url: location.href}).then(res => {
                    if (res.data.Code != 0) {
                        alert(res.data.Message)
                        return
                    }
                    let weixin = res.data.Data
                    wx.config({
                        debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
                        appId: weixin.AppId, // 必填，公众号的唯一标识
                        timestamp: weixin.Timestamp, // 必填，生成签名的时间戳
                        nonceStr: weixin.NonceStr, // 必填，生成签名的随机串
                        signature: weixin.Signature,// 必填，签名
                        jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的 JS 接口列表
                    });
                    wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
                        wx.updateAppMessageShareData({
                            title: this.detail.Name, // 分享标题
                            desc: this.detail.Summary, // 分享描述
                            link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
                            imgUrl: this.detail.Cover, // 分享图标
                            success: function () {
                                // 设置成功
                            }
                        })
                        wx.updateTimelineShareData({
                            title: this.detail.Name, // 分享标题
                            link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
                            imgUrl: this.detail.Cover, // 分享图标
                            success: function () {
                                // 设置成功
                            }
                        })
                    });
                })
            },
        },
    };
</script>
